/* ----------------------------------------------------------
   STYLING QUIZ — FULL JS (Impact-Safe + Query-Safe)
----------------------------------------------------------- */

/* ----- UNBREAKABLE PAGE CHECK (WORKS WITH QUERY STRINGS) ----- */
const rawPath = window.location.pathname.toLowerCase().replace(/\/+$/, "");
const onStylingQuizPage =
  rawPath.endsWith("/pages/styling-quiz") ||
  rawPath.includes("styling-quiz");

console.log("Styling Quiz JS Loaded →", onStylingQuizPage);

/* DO NOT RETURN — Impact theme breaks if you return inside JS */
if (!onStylingQuizPage) {
  // Script stays alive for other pages
}

/* ----- RUN QUIZ CODE ONLY ON THE RIGHT PAGE ----- */
if (onStylingQuizPage) {
  console.log("Styling Quiz ACTIVE ✔");

  /* ---------------- SUBMIT FUNCTION ---------------- */
  window.submitStylingQuiz = function () {
    const concern        = document.querySelector("input[name='stylingConcern']:checked")?.value;
    const hairFeel       = document.querySelector("input[name='hairFeel']:checked")?.value;
    const styleMethod    = document.querySelector("input[name='styleMethod']:checked")?.value;
    const scalpSensitive = document.querySelector("input[name='scalpSensitive']:checked")?.value;
    const desiredOutcome = document.querySelector("input[name='desiredOutcome']:checked")?.value;

    if (!concern || !hairFeel || !styleMethod || !scalpSensitive || !desiredOutcome) {
      alert("Please answer all questions before seeing your routine.");
      return;
    }

    // For now, core match is based on main concern
    displayStylingResult(concern);
  };

  /* ---------------- PRODUCT DATA (VERSION B ORDER) ---------------- */
  const stylingResults = {
    "dry-damaged": {
      heading: "Dry + Damaged Hair Routine",
      subtitle: "Repair, soften, and protect your hair from further damage.",
      products: [
        {
          // HERO treatment first
          name: "Restore + Repair Mask",
          img: "https://www.bella-hue.com/cdn/shop/files/Hair_mask_treatment.png?v=1738451113&width=1000",
          url: "https://www.bella-hue.com/products/new-seasonal-scalp-hair-mask",
          desc: "Weekly (or bi-weekly) deep treatment to repair damage, soften brittle ends, and boost shine."
        },
        {
          // Daily essential second
          name: "Prime + Protect",
          img: "https://www.bella-hue.com/cdn/shop/files/prime_protect_detangler.png?v=1738450808&width=1000",
          url: "https://www.bella-hue.com/products/prime-protect-hair-primer-detangler",
          desc: "Lightweight daily primer to detangle, add slip, and help protect from breakage and heat."
        },
        {
          // Finishing step last
          name: "Reparative Hair Oil",
          img: "https://www.bella-hue.com/cdn/shop/files/Reparative_hair_oil_dry_hair_treatment.png?v=1738450852&width=1000",
          url: "https://www.bella-hue.com/products/tester-group",
          desc: "Silicone-free finishing oil to smooth frizz, add glossy shine, and seal dry, split ends."
        }
      ]
    },

    "curl": {
      heading: "Curl + Wave Routine",
      subtitle: "Hydrate, define, and protect your curls without crunch.",
      products: [
        {
          // Styling hero first
          name: "Curl Cream",
          img: "https://www.bella-hue.com/cdn/shop/files/Curl_cream_silicone_free.png?v=1738449636&width=1000",
          url: "https://www.bella-hue.com/products/curl-cream",
          desc: "Moisturizing cream that defines curls and waves while keeping them soft and touchable."
        },
        {
          // Refresh / hydration second
          name: "Hydro Boost (Re-Coil Spray)",
          img: "https://www.bella-hue.com/cdn/shop/files/Hydro_boost_weightless_moisture_for_hair.png?v=1750099629&width=1000",
          url: "https://www.bella-hue.com/products/re-coil-spray",
          desc: "Weightless moisture mist to refresh curls between wash days and boost bounce without buildup."
        },
        {
          // Prep/primer third
          name: "Prime + Protect",
          img: "https://www.bella-hue.com/cdn/shop/files/prime_protect_detangler.png?v=1738450808&width=1000",
          url: "https://www.bella-hue.com/products/prime-protect-hair-primer-detangler",
          desc: "Use before styling to detangle, add slip, and protect curls from friction and heat."
        }
      ]
    },

    "frizz": {
      heading: "Frizz Control Routine",
      subtitle: "Smooth puffiness and flyaways while keeping hair soft, not sticky.",
      products: [
        {
          // Daily anti-frizz prep first
          name: "Prime + Protect",
          img: "https://www.bella-hue.com/cdn/shop/files/prime_protect_detangler.png?v=1738450808&width=1000",
          url: "https://www.bella-hue.com/products/prime-protect-hair-primer-detangler",
          desc: "Use on damp hair before air-drying or blow-drying to minimize frizz and protect from heat."
        },
        {
          // Oil second
          name: "Reparative Hair Oil",
          img: "https://www.bella-hue.com/cdn/shop/files/Reparative_hair_oil_dry_hair_treatment.png?v=1738450852&width=1000",
          url: "https://www.bella-hue.com/products/tester-group",
          desc: "Smooth a small amount over mid-lengths and ends to tame frizz and add shine."
        },
        {
          // Mask third
          name: "Restore + Repair Mask",
          img: "https://www.bella-hue.com/cdn/shop/files/Hair_mask_treatment.png?v=1738451113&width=1000",
          url: "https://www.bella-hue.com/products/new-seasonal-scalp-hair-mask",
          desc: "Weekly deep moisture treatment to fight the dryness that leads to frizz and puffiness."
        }
      ]
    },

    "itchy": {
      heading: "Itchy / Flaky Scalp Routine",
      subtitle: "Calm irritation, reduce flakes, and keep your lengths soft.",
      products: [
        {
          // Targeted treatment first
          name: "Scalp Repair Oil",
          img: "https://www.bella-hue.com/cdn/shop/files/Scalp_Repair_Overnight_scalp_treatment.png?v=1738451510&width=1000",
          url: "https://www.bella-hue.com/products/new-soothing-scalp-serum",
          desc: "Targeted treatment oil to calm itchiness, redness, and irritation while supporting your scalp barrier."
        },
        {
          // Exfoliation second
          name: "Rosemary Scalp Scrub",
          img: "https://www.bella-hue.com/cdn/shop/files/Scalp_scrub_rosemary_organic.png?v=1738451470&width=1000",
          url: "https://www.bella-hue.com/products/rosemary-scalp-scrub",
          desc: "Use weekly to gently exfoliate dry flakes and product buildup without stripping your scalp."
        },
        {
          // Mask last
          name: "Restore + Repair Mask",
          img: "https://www.bella-hue.com/cdn/shop/files/Hair_mask_treatment.png?v=1738451113&width=1000",
          url: "https://www.bella-hue.com/products/new-seasonal-scalp-hair-mask",
          desc: "Focus on mids to ends to keep hair soft and moisturized while you focus treatments at the scalp."
        }
      ]
    },

    "thinning": {
      heading: "Thinning Hair / Growth Support Routine",
      subtitle: "Support healthier-looking growth and add lightweight lift at the roots.",
      products: [
        {
          // Core system first
          name: "Hair Growth Bundle Kit",
          img: "https://www.bella-hue.com/cdn/shop/files/Hair_growth_collection.png?v=1762880048&width=800",
          url: "https://www.bella-hue.com/products/hair-growth-bundle",
          desc: "A focused system designed to support a balanced scalp and healthier-looking hair growth over time."
        },
        {
          // Styling/instant grip second
          name: "Beauty Queen Texture Powder",
          img: "https://www.bella-hue.com/cdn/shop/files/Beauty_Queen_Max_Volume.png?v=1738449166&width=1000",
          url: "https://www.bella-hue.com/products/beauty-queen-texture-powder",
          desc: "Root-lifting powder to add instant volume, grit, and density at the scalp without heavy residue."
        }
      ]
    }
  };

  /* ---------------- DISPLAY RESULTS ---------------- */
  function displayStylingResult(key) {
    const box = document.getElementById("stylingResult");
    const data = stylingResults[key];

    if (!box || !data) {
      console.warn("Styling result box or data missing for key:", key);
      return;
    }

    const productsHtml = data.products
      .map(
        (p) => `
        <div class="styling-product-card">
          <img src="${p.img}" alt="${p.name}">
          <div class="styling-product-card-title">${p.name}</div>
          <div class="styling-product-card-desc">${p.desc}</div>
          <a href="${p.url}" target="_blank" rel="noopener noreferrer">Shop Now</a>
        </div>
      `
      )
      .join("");

    box.innerHTML = `
      <div class="styling-result-heading">${data.heading}</div>
      <div class="styling-result-subtitle">${data.subtitle}</div>
      <div class="styling-product-grid">
        ${productsHtml}
      </div>
    `;

    box.style.display = "block";
    const restartBtn = document.getElementById("restartStylingQuizBtn");
    if (restartBtn) restartBtn.style.display = "block";

    // Auto-scroll to result so no one misses it
    setTimeout(() => {
      box.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 150);
  }

  /* ---------------- CLICK LISTENER (IMPACT-SAFE) ---------------- */
  document.addEventListener("click", function (e) {
    if (e.target && e.target.id === "stylingSubmitBtn") {
      e.preventDefault();
      submitStylingQuiz();
    }
  });
}

/* -------- END OF FILE -------- */

